import { routePaths } from "../constants/routes";

export const premiumPdfCategories = [
  {
    id: "jira-pack",
    title: "Complete JIRA for QA Engineers",
    level: "Basic to Expert",
    target: "Manual QA, Automation QA, Freshers",
    price: "Rs. 199 - Rs. 499",
    status: "Live",
    highlight: "Featured pack with real QA bug reporting, JQL, Agile, and interview prep.",
    to: routePaths.jiraNotes,
  },
  {
    id: "api-pack",
    title: "API Testing Zero to Hero",
    level: "Basic to Expert",
    target: "QA, SDET, Automation Testers",
    price: "Rs. 299 - Rs. 699",
    status: "Planned",
    highlight: "REST fundamentals, Postman, auth, payload validation, and real project flows.",
  },
  {
    id: "manual-pack",
    title: "Manual Testing Complete Guide",
    level: "Basic to Advanced",
    target: "Freshers",
    price: "Rs. 199 - Rs. 499",
    status: "Planned",
    highlight: "SDLC, STLC, defects, test cases, bug reports, and real-time examples.",
  },
  {
    id: "selenium-pack",
    title: "Selenium with Java Framework PDF",
    level: "Advanced",
    target: "Automation QA",
    price: "Rs. 499 - Rs. 999",
    status: "Planned",
    highlight: "Framework design, POM, TestNG, reporting, waits, and interview questions.",
  },
  {
    id: "sql-pack",
    title: "SQL for Testers",
    level: "Basic to Advanced",
    target: "QA / Data Testing",
    price: "Rs. 199 - Rs. 499",
    status: "Planned",
    highlight: "SQL basics, joins, subqueries, validation scenarios, and data testing use cases.",
  },
  {
    id: "testcase-pack",
    title: "Test Case Writing Master PDF",
    level: "Basic to Advanced",
    target: "Freshers / Manual QA",
    price: "Rs. 199 - Rs. 399",
    status: "Planned",
    highlight: "Scenario writing, boundary cases, negative cases, and review checklist.",
  },
  {
    id: "project-pack",
    title: "Real-Time QA Project Documents Pack",
    level: "Practical",
    target: "Job-ready students",
    price: "Rs. 499 - Rs. 1499",
    status: "Planned",
    highlight: "Test plans, RTM, bug reports, checklists, templates, and real project samples.",
  },
  {
    id: "interview-pack",
    title: "Interview Questions Pack",
    level: "Fresher + Experienced",
    target: "Job seekers",
    price: "Rs. 199 - Rs. 499",
    status: "Planned",
    highlight: "Manual, automation, API, SQL, Agile, and scenario-based interview preparation.",
  },
];

export const monetizationBenefits = [
  "Sell structured PDF products without waiting for full video course completion.",
  "Convert free blog traffic into low-ticket paid learners with simple checkout.",
  "Upsell PDF buyers later into premium live courses, mock interviews, and mentorship.",
  "Use chapter previews and printable layouts to increase perceived value quickly.",
];

export const premiumStoreSteps = [
  "Attract users from free notes, blogs, and interview pages.",
  "Offer a strong preview page with chapter list, outcomes, and sample screenshots.",
  "Route interested learners into a simple premium checkout flow.",
  "Unlock printable PDF-style notes and use email / support upsells later.",
];

